import styled from 'styled-components'

export const ConversationTelemetryScrollStyled = styled.div`
  max-height: ${(props) => props.theme.typography.pxToRem(200)};
  overflow-y: auto;
  padding-bottom: ${(props) => props.theme.space.small};
`
